import { useEffect, useMemo, useState } from 'react'
import keys from 'lodash/keys'

export type Confirmations = {
  isConfirmed: (key: string, signature: string) => boolean
  touched: ReadonlySet<string>
  confirm: (key: string, signature: string) => void
  unconfirm: (key: string) => void
}

export function useConfirmations(resetOn: unknown): Confirmations {
  const [signatures, setSignatures] = useState<Record<string, string | null>>({})

  useEffect(() => {
    setSignatures({})
  }, [resetOn])

  const touched = useMemo(() => new Set(keys(signatures)), [signatures])

  return {
    isConfirmed: (key, signature) => signatures[key] === signature,
    touched,
    confirm: (key, signature) => setSignatures((current) => ({ ...current, [key]: signature })),
    unconfirm: (key) => setSignatures((current) => ({ ...current, [key]: null }))
  }
}
